<template lang="html">

  <section class="opt_group">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="opt_group_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.opt_group_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">OPT Groups</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">
             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.opt_group_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-if="false" v-b-modal.modal-new-int-lab @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-if="false"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-if="false"><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table ref="opt_group_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > 
            <!-- isMandatoryCheckBox Button -->
              <template v-slot:cell(isMandatoryCheckBox)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="!data.item.mandatory" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Mandatory to True" @click="data.item.mandatory=true; curItem=data.item; toggleAndSaveStatus(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Mandatory to False" @click="data.item.mandatory=false; curItem=data.item; toggleAndSaveStatus(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </h4>
                </b-row>
              </template>


            <!-- isExclusiveCheckBox Buttons -->
              <template v-slot:cell(isExclusiveCheckBox)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="!data.item.exclusive" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Exclusive to True" @click="data.item.exclusive=true; curItem=data.item; toggleAndSaveStatus(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Exclusive to False" @click="data.item.exclusive=false; curItem=data.item; toggleAndSaveStatus(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </h4>
                </b-row>
              </template>     
              
                 <!-- A custom comparisonEquipmentPos -->
               <template v-slot:cell(comparison)="data" lang="html">
                <b-row>
                 <p class="panel-title" style="margin:auto; text-align:center;">
                   {{data.item.comparisonEquipmentPos}}
                </p>
                </b-row>
              </template>      
              <!-- A custom formatted column -->
              <!-- A custom comparisonEquipmentPos -->
               <template v-slot:cell(selectGroup)="data" lang="html">
                <b-row>
                 <b-form-select id="groupType-select" v-model="data.item.groupType" class="col-lg-12"  @change="curItem=data.item; onChangeSaveStatus(data.item)">
                   <template v-for = "opt in getGroupTypeList">
                     <b-form-select-option v-if = "opt == data.item.groupType" selected :value="opt">{{opt}}</b-form-select-option>
                     <b-form-select-option v-else :value="opt">{{opt}}</b-form-select-option>
                   </template>                  
                </b-form-select>
                 <p class="panel-title" style="margin:auto; text-align:center;">                  
                </p>
                </b-row>
              </template>      
              <!-- A custom formatted column -->
              <template v-slot:cell(save_button)="data" lang="html">
                <b-row>
                    <h4 class="panel-title" style="margin:auto;">                                        
                      <a role="button" data-toggle="collapse" href="javascript:void(0);"  aria-expanded="true" aria-controls="collapseOne">
                      <b-button variant="primary mr-1" @click="curItem=data.item; onChangeSaveStatus(data.item)"> SAVE <i class="mdi mdi-content-save"></i></b-button>
                      </a>
                    </h4>
                  </b-row>
                <b-row>                 
                 <p class="panel-title" style="margin:auto; text-align:center;">                  
                </p>
                </b-row>
              </template>      
            <!-- A custom formatted column -->
            <template v-slot:cell(subgroup_input)="data" lang="html">              
                <b-row>                                    
                  <input type="text" class="col-lg-12" v-model="data.item.mandatorySubgroup" placeholder="mandatorySubgroup"/>
                </b-row>
            </template>
            <!-- A custom formatted column -->
            <template v-slot:cell(comparison_eq)="data" lang="html">              
                <b-row>                                    
                  <input type="text" class="col-lg-12" v-model="data.item.comparisonEquipmentPos" placeholder="comparisonEquipmentPos"/>
                </b-row>
            </template>
            <b-tooltip target="tooltip-target-1" triggers="hover">                    
            </b-tooltip>

            </b-table>
            <b-modal id="opt-color-details" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <b-table ref="opt_group_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->

            </b-table>
                </b-row>
             </b-container>
            </b-modal>
            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" disabled/>
                  <div class="col-lg-3">Label*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.label"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Model Enabled (regexp)*:</div><input type="text" class="col-lg-3" placeholder="Model Enabled (regexp)" v-model="curItem.modelEnableRegexp"/>
                  <div class="col-lg-3">Model Disabled (regexp)*:</div><input type="text" class="col-lg-3" placeholder="Model Disabled (regexp)" v-model="curItem.modelDisableRegexp"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new-int-lab" title="New Interface Label"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Label Group*:</div>
                  <b-form-select id="labelGroup-dd" v-model="newItem.labelGroup" class="col-lg-3">
                    <!--<b-form-select-option v-for = "lg in getLabelGroupList" :value="lg">{{lg}}</b-form-select-option>-->
                  </b-form-select>
                </b-row>
                <hr>
                  <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code" />
                  <div class="col-lg-3">Label*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.label"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Model Enabled (regexp)*:</div><input type="text" class="col-lg-3" placeholder="Model Enabled (regexp)" v-model="newItem.modelEnableRegexp"/>
                  <div class="col-lg-3">Model Disabled (regexp)*:</div><input type="text" class="col-lg-3" placeholder="Model Disabled (regexp)" v-model="newItem.modelDisableRegexp"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'opt_group',
  methods: {
    expandItem(element){
      console.log(element)
      this.accordionManager()
    },
    accordionManager () {
      document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
        var tr = document.createElement('tr')
        tr.className = 'expandableContent closed';
        var td = document.createElement('td')
        td.setAttribute('colspan',6);
        td.style.backgroundColor = 'yellow';  

        tr.appendChild(td);
        el.parentNode.appendChild(tr);
        el.parentNode.insertBefore(el,tr)
      })
    },
    onChangeSaveStatus(item) {
      this.$bvModal.msgBoxConfirm('Vuoi Salvare l\'elemento selezionato?', {
        title: 'Salvataggio Elemento',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.saveCurItem(item);         
        }      
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    toggleAndSaveStatus(item,visibilityValue) {
      this.$bvModal.msgBoxConfirm('Vuoi impostare il valore a '+visibilityValue+' per '+item.code+'?', {
        title: 'Cambio Stato',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.saveCurItem(item);         
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    saveCurItem(curItem) {
      window.curr = curItem
      var intLabObj =  curItem;
      if(isNaN(intLabObj.comparisonEquipmentPos)){
         this.$bvModal.msgBoxOk("il campo Comparison Equipment Position deve essere un numero", {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }
      else{
      this.setSpinnerStatus(true);
      this.axios
        .put('/ccb/auth/fe/optGroup/' + curItem.id, intLabObj ,this.authHeader)
        .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-edit');
      })
    }
    },
    createItem() {
      this.setSpinnerStatus(true);
      var intLabObj = this.newItem     
      intLabObj.optGroup = {id: this.getCurLanguageObj.id}
      this.axios
        .post('/ccb/auth/fe/optGroup', intLabObj, this.authHeader)
        .then(response => {
          if(response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: true,
              centered: true
            })
            .then(value => {
              this.refreshTable();
            })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-new-int-lab');
        })
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true); 
      var params = {
            optGroup: this.getCurLabelGroup, modelName: this.getCurModel, optGroup: this.getCurLanguage, 
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/optGroup/allPaged' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
            console.log(response.data)
            window.datas = response.data;
          this.setOptGroupListAdm(response.data.content)                   
          this.totalRowsResult=response.data.totalElements;      
           this.setSpinnerStatus(false);   
          });
    },
     refreshTable() {
      this.search();
    },
    btnNew() {
      setTimeout(() => {
        var atG = this.getCurLabelGroup
        document.querySelector('#labelGroup-dd').querySelector('option[value="'+atG+'"]').selected = true  
      }, 500);
      
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setOptGroupListAdm'
      
    ]),
    loadLanguages () {
       this.axios
      .get('/ccb/auth/fe/optGroup/langlist' ,  {
        params:null,
        ...this.authHeader}
          
          )
          .then((response) => {
            localStorage.setItem('langList', JSON.stringify(response.data));
            this.setLanguageList(response.data);          
          });
    },
  },
  props: ['action','activeGroup'],
  data () {
    return {
      allLanguages: [],
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'code',      
      sortDesc: false,
      curItem:null,
      newItem : {id:null, optGroup: null,  labelGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null},      
      fields: [
        {
          key: 'code',
          label: 'Code',
          sortable: false
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false
        },
        {
          key: 'selectGroup',
          label: 'Group Type',
          sortable: false
        },
        {
          key: 'isExclusiveCheckBox',
          label: 'Is Exclusive',
          sortable: false
        },
        {
          key: 'isMandatoryCheckBox',
          label: 'Is Mandatory',
          sortable: false
        },
        {
          key: 'subgroup_input',
          label: 'Mandatory subgroup',
          sortable: false
        },
        {
          key: 'comparison_eq',
          label: 'Comparison Equipment Position (NULL = hide)',
          sortable: false
        },
        {
          key: 'save_button',
          label: 'Save Element',
          sortable: false
        }         
      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    getAllLanguages(){
      return this.allLanguages;
    },
    items () {
      return (this.getOptGroupListAdm && this.getOptGroupListAdm.length) ? this.getOptGroupListAdm : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',
       'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getOptGroupListAdm',
      'getGroupTypeList'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {   
    },
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this
    this.search();     
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw !important;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
